import { AxiosInstance } from 'axios';
import { EventClassDto } from '@sweatpals/shared';
import { httpClient } from '../data-services';

export class EventClassesService {
	constructor(private readonly httpClient: AxiosInstance) {}

	public async getEventClasses(
		eventBaseId: string,
		shortInstance: string,
		filter?: { eventPriceBaseId?: string }
	): Promise<EventClassDto[]> {
		const { data } = await httpClient.get(
			`/event-classes/${eventBaseId}/short-instance/${shortInstance}/event-classes`,
			{ params: filter }
		);

		return data;
	}

	public async getTicketClasses(ticketId: string): Promise<EventClassDto[]> {
		const { data } = await httpClient.get(`/event-classes/ticket/${ticketId}/event-classes`);

		return data;
	}

	public async upsertTicketClasses(ticketId: string, eventClassIds: string[]): Promise<EventClassDto[]> {
		const { data } = await httpClient.post(`/event-classes/ticket/${ticketId}/event-classes`, eventClassIds);

		return data;
	}
}
